import api from "../../../../../Shared/Config/AxiosInstance";
import { ApiResponse } from "../../../../../Shared/Model/ApiResponse";
import MetricDataSource from "../MetricDataSource";
import { MetricApiEntity, MonthlySales, TopSellingProducts } from "./Entity/MetricProductApiEntity";


const routeName = `/v1/Metrics`;
export default class MetricAPIDataSourceImpl implements MetricDataSource {

    async getMetrics(): Promise<MetricApiEntity> {
      try {
        const response = await api.get<ApiResponse<any>>(routeName);
        // console.log(response.data.data);
        const data = response.data.data;

        if (data && Array.isArray(data.topSellingProducts)) {
                    const topProducts: TopSellingProducts[] = data.topSellingProducts.map((item: TopSellingProducts) => ({
                      productId: item.productId,
                      productName: item.productName,
                      productImageUrl: item.productImageUrl,
                      stock: item.stock,
                      totalQuantitySold: item.totalQuantitySold
          }));

          return {
            totalSalesCount: data.totalSalesCount,
            activeUsersCount: data.activeUsersCount,
            topSellingProducts: topProducts,
            activeOrders: data.activeOrders,
        };
        } else{
          throw new Error("La respuesta no tiene el formato esperado");
        }

        
      } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al obtener los clientes:", error);
        throw new Error("Error al obtener los clientes");
      }
    }

    async getLowStockProducts(): Promise<TopSellingProducts[]> {
      try {
        const response = await api.get<ApiResponse<any>>(`${routeName}/low-stock-products`);
        const data = response.data.data;

        if (data && Array.isArray(data)) {
            const lowStockProducts: TopSellingProducts[] = data.map((item: TopSellingProducts) => ({
              productId: item.productId,
              productName: item.productName,
              productImageUrl: item.productImageUrl,
              stock: item.stock,
              isCritical: item.isCritical
          }));

          return lowStockProducts;
        } else{
          throw new Error("La respuesta no tiene el formato esperado");
        }

        
      } catch (error) {
        // Maneja errores de solicitud
        console.error("Error al obtener los productos con bajo stock:", error);
        throw new Error("Error al obtener los productos con bajo stock");
      }
    }

    async getMonthlySales(year: number): Promise<MonthlySales[]> {
      try {
        const response = await api.get<ApiResponse<any>>(`${routeName}/monthly-sales`, { params: { year } });
        const data = response.data.data;

        if (data && Array.isArray(data)) {
            const monthlySales: MonthlySales[] = data.map((item: MonthlySales) => ({
              month: item.month,
              totalSales: item.totalSales
          }));

          return monthlySales;
        } else{
          throw new Error("La respuesta no tiene el formato esperado");
        }

      } catch (error) {
        console.error("Error al obtener las ventas:", error);
        throw new Error("Error al obtener las ventas mensuales");
      }
    }
}